<div class="main-container">
  <div class="left-container">
    Drop Down Lists
    <div class="table-container">
      <table mat-table [dataSource]="dentalBidirectionalListsDataSource" class="list-table" matSort>
        <!-- Name -->
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let list"> {{list.name}} </td>
        </ng-container>
        <!-- Description -->
        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let list"> {{list.description}} </td>
        </ng-container>
        <!-- Action -->
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
          <td mat-cell *matCellDef="let list" (click)="editList(list)">
            <div class="table-row-action">
              <i class="fa-light fa-pen-to-square" tooltip="Edit"></i>
            </div>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="dentalBidirectionalListsDisplayColumns"></tr>
        <tr mat-row *matRowDef="let row; let i = index; columns: dentalBidirectionalListsDisplayColumns;"
            [class.active]="selectedList?.id === row.id" (dblclick)="editList(row)">
        </tr>


      </table>
    </div>
  </div>
  <div class="right-container">
    <div class="right-container-header">
      <div *ngIf="selectedList" class="actionable-header">
        <div class="title">
          List Items for {{selectedList?.name}}
        </div>
      </div>
      <div *ngIf="!selectedList">
        <i class="fa-light fa-left"></i>
        Select drop down list to load list items.
      </div>
    </div>
    <div class="templateListItems">
      <div class="top-actions">
        <div class="toggle-list-item-button">
          <mat-checkbox [(ngModel)]="showInactive" (change)="toggleActiveListItems()">Show Inactive</mat-checkbox>
        </div>
      </div>
      <div cdkDropList class="draggable-list-container" (cdkDropListDropped)="drop($event)">
        <div class="draggable-list-item" *ngFor="let item of visibleListItems" cdkDrag>
          <div class="list-item-title">
            <i class="fa-regular fa-grip-dots-vertical"></i>
            {{item.name}}
          </div>
          <div class="right-list-item">
            <div class="list-item-details">
              <i *ngIf="!item.active" class="fa-light fa-eye-slash"></i>
            </div>
            <div class="list-item-actions">
              <i class="fa-light fa-pen-to-square" tooltip="Edit" (click)="editListItem(item)"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-actions">
        <button mat-raised-button (click)="saveListOrder()">
          <div class="button-icon">
            <i class="fa-light fa-floppy-disk"></i> Save
          </div>
        </button>
        <button mat-raised-button (click)="sortListItems()">
          <div class="button-icon">
            <i class="fa-light fa-arrow-down-a-z" tooltidp="Sort List Items"></i> Sort
          </div>
        </button>
        <button mat-raised-button (click)="addNewListItem()" tooltip="Add List Item">
          <div class="button-icon">
            <i class="fa-light fa-square-plus"></i> Add
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
